var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApplicationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4690FF",
  d: "M8.242 10.586h3.516v1.172H8.242z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4690FF",
  d: "M16.226 11.758H12.93v.586a.586.586 0 0 1-.586.586H7.656a.586.586 0 0 1-.586-.586v-.586H3.774a1.76 1.76 0 0 1-1.667-1.202L0 4.235V17.03c0 .97.789 1.758 1.758 1.758h16.484A1.76 1.76 0 0 0 20 17.031V4.235l-2.107 6.321a1.76 1.76 0 0 1-1.667 1.202"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#4690FF",
  d: "M12.344 1.21H7.656A1.76 1.76 0 0 0 5.9 2.97v.586h-4.89l2.21 6.63c.08.24.303.4.555.4H7.07V10c0-.324.263-.586.586-.586h4.688c.324 0 .586.262.586.586v.586h3.296c.252 0 .476-.16.556-.4l2.21-6.631h-4.89v-.586a1.76 1.76 0 0 0-1.758-1.758M7.07 3.556v-.586c0-.324.263-.586.586-.586h4.688c.323 0 .586.262.586.586v.586z"
})));
export default SvgApplicationIcon;